module.exports = __webpack_public_path__ + "img/cusetomerImg4.56332d78.png";